<h1 mat-dialog-title>Save ProgramAccrualRates Report </h1>
<p class="saveAccrualRatesReportSubheading">Create and save the program accrual rates report to the program.</p>
<div class="saveAccrualRatesReportButtons">
  <button mat-raised-button class="functional-button-dark" (click)="Confirm()" [mat-dialog-close]="data"> Save</button>
  <button mat-raised-button class="functional-button" (click)="Cancel()"> Cancel</button>
</div>